<script>
  import DynamicHeading from "../atoms/DynamicHeading.svelte";
  import DynamicHeadingContext from "../atoms/DynamicHeadingContext.svelte";
  import Grid from "../atoms/Grid.svelte";

  // @ts-check

  import GridContainer from "../atoms/GridContainer.svelte";
  import LinkCard from "../molecules/Cards/LinkCard.svelte";
  import { setContext } from "svelte";

  /** @type { string } */
  let className = "";
  export { className as class };

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /**
   * The optional title for the centered layout
   * @type {string}
   */
  export let title = null;

  /**
   * The optional card to display on the right side of the centered layout
   * @type {object}
   * @property {string} title
   * @property {import('../types/shared.js').Image} featuredImage
   * @property {import('../types/shared.js').CTA} cta
   * @property {import('../utilities/themes.js').ThemeName} theme
   */
  export let linkCard = null;

  setContext("CenteredLayout", true);

  const commonGridClasses = "col-full-width md:col-span-8 md:col-start-3";

  const hasExtraSmallTitle = title && title.length > 30;
</script>

<DynamicHeadingContext>
  <GridContainer {id} containerElement="section" containerClass={className}>
    <Grid gridClass="sm:max-lg:gap-y-10">
      {#if title}
        <div class="{commonGridClasses} lg:col-span-3">
          <DynamicHeading class={hasExtraSmallTitle ? "heading-xs" : "heading-sm"}>
            {title}
          </DynamicHeading>
        </div>
      {/if}
      <!-- TODO: Remove when the DynamicHeadings component is implemented -->
      <div data-headings-increment class="{commonGridClasses} lg:col-span-6 lg:col-start-4">
        <slot />
      </div>
      {#if linkCard}
        <div class="{commonGridClasses} lg:relative lg:col-span-3 lg:col-start-10">
          <div class="w-full lg:absolute lg:bottom-0">
            <LinkCard {...linkCard} />
          </div>
        </div>
      {/if}
    </Grid>
  </GridContainer>
</DynamicHeadingContext>
